import { IconButton, IconButtonProps, Tooltip, TooltipProps } from '@mui/material';

type IconButtonWithTooltipProps = IconButtonProps & {
    TooltipProps: Omit<TooltipProps, 'children'>;
};

const IconButtonWithTooltip = ({ TooltipProps, ...props }: IconButtonWithTooltipProps) => (
    <Tooltip
        arrow
        slotProps={{
            popper: {
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -14],
                        },
                    },
                ],
            },
        }}
        {...TooltipProps}
    >
        <IconButton
            {...props}
            style={{
                pointerEvents: 'auto',
            }}
        />
    </Tooltip>
);

export { IconButtonWithTooltip };
export type { IconButtonWithTooltipProps };
